module.exports.config = {
  "declarative": true,

  "render-module": {
    "name": "PieceSelectMarketRenderModule",
    "path": "front/piece-select-market-render.module"
  },

  "definition": {
    "name": "PieceSelectMarketDefinition",
    "type": "select-market",
    "group": "Components",
    "availablePlatforms": ["web"],
    "description": "Selector de mercado",
    "fields": [
      {
        "name": "textColors",
        "label": "Color de texto",
        "type": "color",
        "mandatory": false
      }
    ],
    "analytics": [
      "access-market",
      "preselect-language",
      "preselect-region"
    ]
  }
};
